module.exports = __webpack_public_path__ + "51cceb5ab1fdbb62025a230ecc7e999e.png";